import { useReducer } from "react";
import {
  type DetailedProgress,
  type UploadAction,
  UploadActionType,
} from "./uploadTypes";

export function useUploadReducer(): [UploadState, (a: UploadAction) => void] {
  return useReducer(uploadReducer, {
    stage: UploadStage.SELECT,
  });
}

function uploadReducer(state: UploadState, action: UploadAction): UploadState {
  if (action.type === UploadActionType.ERROR)
    return { stage: UploadStage.ERROR, message: action.payload.message };

  switch (state.stage) {
    case UploadStage.SELECT:
      if (action.type === UploadActionType.START) {
        return {
          stage: UploadStage.PROGRESS,
          title: action.payload.fileName,
        };
      }
      return state;
    case UploadStage.PROGRESS:
      if (action.type === UploadActionType.PROGRESS) {
        return { ...state, ...action.payload };
      }
      return state;
  }

  return state;
}

export type UploadState =
  | { stage: UploadStage.SELECT }
  | { stage: UploadStage.ERROR; message: string }
  | {
      stage: UploadStage.PROGRESS;
      title: string;
      progress?: DetailedProgress;
    };

export enum UploadStage {
  SELECT,
  PROGRESS,
  ERROR,
}
